const isInboundFromNbly = () => {
  const windowUrl = globalThis.location.search;
  const params = new URLSearchParams(windowUrl);
  return params.has("leadconcept");
};

export const clearSessionOffer = () => {
  const oldURL = sessionStorage.getItem("landing-page-url");
  const oldParams = new URLSearchParams(oldURL ?? "");
  const newParams = new URLSearchParams(window.location.search);
  if (oldParams.get("leadconcept") !== newParams.get("leadconcept"))
    sessionStorage.removeItem("offerDetails");
};

export default isInboundFromNbly;
